module.exports = __webpack_public_path__ + "img/sobre-zama-m.c8f9b9b8.png";